{
  "id": "craft-block-actions",
  "faces": "horizontal",
  "defaultLayout": "actions",
  "colors": {
    "background": "rgba(18, 22, 28, 0.72)",
    "border": "#5cefff",
    "buttonBackground": "rgba(28, 34, 42, 0.88)",
    "buttonHoverBackground": "rgba(0, 210, 240, 0.42)",
    "buttonBorder": "#2a3340",
    "text": "#b8c4ce",
    "textHover": "#e8fdff",
    "iconFill": "#5cefff",
    "iconHoverFill": "#e8fdff",
    "iconStroke": "#12161c",
    "iconHoverStroke": "#12161c",
    "iconStrokeWidth": 7,
    "iconHoverStrokeWidth": 7,
    "tooltipBackground": "rgba(18, 22, 28, 0.94)",
    "tooltipText": "#e8fdff",
    "tooltipBorder": "#5cefff"
  },
  "layouts": [
    {
      "id": "actions",
      "template": "rows3",
      "content": {
        "direction": "column",
        "align": "center",
        "fontScale": 0.09
      },
      "buttons": [
        {
          "id": "save",
          "text": "Save as new",
          "tooltip": "Save this draft as a new custom block"
        },
        {
          "id": "overwrite",
          "text": "Overwrite",
          "tooltip": "Overwrite the loaded custom block"
        },
        {
          "id": "reset",
          "text": "Reset",
          "tooltip": "Clear the current craft draft"
        }
      ]
    }
  ]
}
